// images.js

import logo from './svg/logo.svg'
import widget1 from './images/widget1.jpg'
import services1 from './svg/services1.svg'
import services2 from './svg/services2.svg'
import services3 from './svg/services3.svg'
import services4 from './svg/services4.svg'
import services5 from './svg/services5.svg'
import services6 from './svg/services6.svg'
import services7 from './svg/services7.svg'
import services8 from './svg/services8.svg'

import about1 from './images/about1.jpg'
import about2 from './images/about2.jpg'
import about5 from './images/about5.jpg'
import about6 from './images/about6.jpg'
import about7 from './images/about7.jpg'
import about8 from './images/about8.jpg'
import about9 from './images/about9.jpg'
import about10 from './images/about10.jpg'
import about11 from './images/about11.jpg'
import hero1 from './images/hero1.jpg'
import hero2 from './images/hero2.jpg'
import heroTablet1 from './images/heroTablet1.jpg'
import heroTablet2 from './images/heroTablet2.jpg'
import heroMobile1 from './images/heroMobile1.jpg'
import heroMobile2 from './images/heroMobile2.jpg'
import cateTabDogs from './images/cateTabDogs.jpg'

import populatedBackground from './images/populated_background2.jpg'
import populatedBackground5 from './images/populated_background5.jpg'
import populatedBackground6 from './images/populated_background6.jpg'

import populated1 from './svg/populated1.svg'
import populated2 from './svg/populated2.svg'

import reviewerAvt1 from './images/review__avt1.jpg'

import brand1 from './img/ricky-14.png'
import brand2 from './img/ricky-15.png'
import brand3 from './img/ricky-16.png'
import brand4 from './img/ricky-17.png'
import brand5 from './img/ricky-18.png'
import brand6 from './img/ricky-19.png'
import brand7 from './img/ricky-20.png'
import brand8 from './img/ricky-21.png'
const images = {
  logo: logo,
  widget1: widget1,
  services1: services1,
  services2: services2,
  services3: services3,
  services4: services4,
  services5: services5,
  services6: services6,
  services7: services7,
  services8: services8,
  about1: about1,
  about2: about2,
  about5: about5,
  about6: about6,
  about7: about7,
  about8: about8,
  about9: about9,
  about10: about10,
  about11: about11,
  hero1: hero1,
  hero2: hero2,
  heroTablet1: heroTablet1,
  heroTablet2: heroTablet2,
  heroMobile1: heroMobile1,
  heroMobile2: heroMobile2,

  populatedBackground: populatedBackground,
  populatedBackground5: populatedBackground5,
  populatedBackground6: populatedBackground6,
  populated1: populated1,
  populated2: populated2,
  cateTabDogs: cateTabDogs,
  reviewerAvt1: reviewerAvt1,

  brand1: brand1,
  brand2: brand2,
  brand3: brand3,
  brand4: brand4,
  brand5: brand5,
  brand6: brand6,
  brand7: brand7,
  brand8: brand8,
}

export default images
